import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Button, Form, Col, Row, Card, message, Spin } from "antd";
import {
  TextInputFI,
  FileUploadFI,
} from "../../../components/commons/HookFormInputs";
import settingService from "../../../services/settingService";

const SettingContainer = () => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { isValid, isDirty },
  } = useForm({
    defaultValues: {},
  });
  const [messageApi, contextHolder] = message.useMessage();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    settingService
      .getSetting("connecting")
      .then((data) => {
        reset(data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        messageApi.open({
          type: "error",
          content: error,
        });
      });
  }, []);

  const onSubmit = (data) => {
    setIsLoading(true);
    settingService
      .updateSetting("connecting", data)
      .then(() => {
        setIsLoading(false);
        reset(data);
        messageApi.open({
          type: "success",
          content: "The connecting info has been updated!",
        });
      })
      .catch((error) => {
        setIsLoading(false);
        messageApi.open({
          type: "error",
          content: error,
        });
      });
  };

  return (
    <>
      {contextHolder}
      <Spin tip="Loading..." spinning={isLoading}>
        <Card
          title="Connecting Info"
          bordered={false}
          extra={
            <Button
              disabled={!isValid || isLoading || !isDirty}
              onClick={handleSubmit(onSubmit)}
              type="primary"
            >
              Update
            </Button>
          }
        >
          <Form layout="vertical">
            <Row gutter={16}>
              <Col span={12}>
                <TextInputFI control={control} name="name" label="Name" />
              </Col>
              <Col span={12}>
                <TextInputFI control={control} name="phone" label="Phone" />
              </Col>
              <Col span={12}>
                <TextInputFI control={control} name="email" label="Email" />
              </Col>
              <Col span={12}>
                <TextInputFI
                  control={control}
                  name="linkinLink"
                  label="Linkin Link"
                />
              </Col>
              <Col span={12}>
                <TextInputFI
                  control={control}
                  name="behanceLink"
                  label="Behance Link"
                />
              </Col>
              <Col span={12}>
                <TextInputFI
                  control={control}
                  name="dribbbleLink"
                  label="Dribbble Link"
                />
              </Col>
              <Col span={12}>
                {/* <FileUploadFI
                  control={control}
                  name="cvFileUrl"
                  label="CV File"
                /> */}
              </Col>
            </Row>
          </Form>
        </Card>
      </Spin>
    </>
  );
};

export default SettingContainer;
